<script lang="ts">
	import type { Snippet } from 'svelte';

	interface Props {
		type?: 'tip' | 'warning' | 'example' | 'note';
		title?: string;
		children: Snippet;
	}

	let { type = 'note', title, children }: Props = $props();

	const surface = $derived(
		type === 'tip' ? 'border-marge/20 bg-marge-pale'
		: type === 'note' ? 'border-encre/25 bg-encre-pale'
		: 'border-mist bg-warm-surface'
	);
	const lead = $derived(
		type === 'warning' ? 'À éviter.' : type === 'tip' ? 'Astuce.' : type === 'example' ? 'Exemple.' : null
	);
	const leadColor = $derived(type === 'warning' ? 'text-danger' : 'text-ink');
</script>

<aside class="not-prose my-8 rounded border p-5 md:p-6 {surface}">
	{#if title}
		<p class="mb-2 font-semibold text-ink">{title}</p>
	{:else if lead}
		<p class="mb-2">
			<strong class="font-semibold {leadColor}">{lead}</strong>
		</p>
	{/if}
	<div class="text-base leading-relaxed text-ink">
		{@render children()}
	</div>
</aside>
